<template>
  <b-row v-if="show">
    <b-col cols="12" class="text-center">
      <i class="fa fa-circle-o-notch fa-spin loading" v-if="isLoading"></i>
      <p v-if="!isLoading && showNoItems && !firstLoad">{{ noItemsText }}</p>
    </b-col>
  </b-row>
</template>
<script>

export default {
  name: 'Loading',
  props: [ 'isLoading', 'items', 'noItemsText' ],
  computed: {
    show () {
      return this.isLoading || this.showNoItems
    },
    showNoItems () {
      return (this.items && this.items.length == 0 && this.noItemsText)
    }
  },
  data () {
    return {
      firstLoad: true
    }
  },
  watch: {
    isLoading () {
      this.firstLoad = false
    }
  }
}
</script>

<style lang="scss">
i {
  &.loading {
    font-size: 2rem;
  }
}
</style>
